import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/utils/utils';
import { UserSelectorAvatar } from './UserSelectorAvatar';
import { Role } from '@momentum/types';
import { getEmployeeRoleDisplayName } from '@/shared/utils/role-utils';

export type UserSelectorEmployee = {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  isActive: boolean;
  imageUrl?: string;
  role?: Role;
  isTeamMember?: boolean;
};

interface UserSelectorItemProps {
  employee: UserSelectorEmployee;
  isSelected: boolean;
  isMultiSelect: boolean;
  onToggle: (employeeId: string) => void;
}

export const UserSelectorItem: React.FC<UserSelectorItemProps> = ({
  employee,
  isSelected,
  isMultiSelect,
  onToggle,
}) => {
  const { t } = useTranslation('common');

  return (
    <div
      onClick={() => onToggle(employee.id)}
      className={cn(
        'flex items-center p-3 border-b border-gray-100 last:border-b-0',
        !employee.isActive
          ? 'opacity-50 cursor-not-allowed'
          : 'hover:bg-gray-50 cursor-pointer'
      )}
    >
      {isMultiSelect && (
        <input
          type="checkbox"
          checked={isSelected}
          disabled={!employee.isActive}
          className="me-3 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded disabled:opacity-50"
        />
      )}

      <UserSelectorAvatar
        imageUrl={employee.imageUrl}
        fullName={employee.fullName}
        className="me-3"
        size="md"
      />

      <div className="flex-1">
        <p
          className={cn(
            'text-sm font-medium',
            !employee.isActive ? 'text-gray-400' : 'text-gray-900'
          )}
        >
          {employee.fullName}
        </p>
        {employee.role && (
          <p className="text-xs text-muted-foreground">
            {getEmployeeRoleDisplayName(employee.role, t)}
          </p>
        )}
      </div>
    </div>
  );
};
